import { useStore } from "vuex";
import type { Notification } from "@/types";

export function useShowNotification() {
  const store = useStore();

  function showNotification(notification: Notification) {
    store.commit("notifications/showNotification", notification);
  }

  function clearNotification(notification: Notification | undefined = undefined) {
    store.commit("notifications/clearNotification", notification);
  }

  return {
    showNotification,
    clearNotification,
  };
}
